module.exports = __webpack_public_path__ + "img/1007_pc.790f59f6.gif";